"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MC_LANDING_PAGE_URL = exports.remoteSalesToolsUrl = exports.getDTTUrl = exports.getInboundPricingFaqUrl = exports.getGettingStartedPageUrl = exports.getCmsHubRootUrl = exports.getCmsRootUrl = exports.getActiveQuoteUrl = exports.getPaidUserManagementUrl = exports.getCommunityUrl = exports.getHSFSApplicationURL = exports.getHSFSPurchaseUrl = exports.getBrazilPromotionUrl = exports.getLatamEsPromotionUrl = exports.getHubSpotHomeUrl = exports.getContactUsUrl = exports.getHubspotForStartupsLandingPageUrl = exports.getPrivacyPolicySiteDomain = exports.getLegalStuffSiteDomain = exports.getProductsAndServicesCatalogUrl = exports.getSuiteLegalDisclaimerUrl = exports.langToUrl = exports.getProductTabUrl = exports.getPricingAndFeaturesPageUrl = exports.getPricingPageUrl = exports.getNotFoundUrl = exports.getRootUrl = exports.handleRedirect = exports.tabsNavigateTo = exports.navigateTo = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _underscore = require("underscore");

var _getLang = _interopRequireDefault(require("I18n/utils/getLang"));

var _enviro = _interopRequireDefault(require("enviro"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _params = require("hub-http/helpers/params");

var _url = require("hub-http/helpers/url");

var _publicPageUrls = require("./publicPageUrls");

var _Raven = _interopRequireDefault(require("Raven"));

var _hubspotPluginCommon = require("hubspot-plugin-common");

var _queryParamUtils = require("./queryParamUtils");

var suffix = _enviro.default.getShort() === 'qa' ? 'qa' : '';

var _createInternalUrl = function _createInternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 ? arguments[1] : undefined;
  var queryString = query && (0, _underscore.compact)(Object.values(query || {})).length ? "?" + (0, _params.stringify)(query) : '';
  var baseUrl = "/" + path;
  return "" + baseUrl + queryString;
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 ? arguments[1] : undefined;
  var urlOptions = {
    protocol: 'https',
    hostname: "app.hubspot" + suffix + ".com",
    path: path,
    query: (0, _params.stringify)(query)
  };
  return (0, _url.buildUrl)(urlOptions);
};

var navigateTo = function navigateTo(url) {
  if (_hubspotPluginCommon.isWordPress) {
    window.open(url, '_top');
  } else {
    window.location = url;
  }
};

exports.navigateTo = navigateTo;

var tabsNavigateTo = function tabsNavigateTo(_ref) {
  var path = _ref.path,
      history = _ref.history;
  //For MON224 - save the show-tts-isc-chat param if present
  var queryParams = (0, _queryParamUtils.getQueryParams)();
  var paramsToSave = ['upgradeSource', 'show-tts-chat'];
  var pathWithSavedParams = path;

  if (paramsToSave.some(function (paramName) {
    return paramName in queryParams;
  })) {
    // Finds any paramsToSave and adds them to the new query if present
    pathWithSavedParams += "?" + paramsToSave.reduce(function (acc, paramName) {
      return paramName in queryParams ? [].concat((0, _toConsumableArray2.default)(acc), [paramName + "=" + queryParams[paramName]]) : acc;
    }, []).join('&');
  }

  history.push(pathWithSavedParams);
  window.scrollTo(0, 0);
};

exports.tabsNavigateTo = tabsNavigateTo;

var handleRedirect = function handleRedirect(url) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  setTimeout(function () {
    navigateTo(url);
  }, delay);
};

exports.handleRedirect = handleRedirect;

var getRootUrl = function getRootUrl() {
  return _createInternalUrl();
};

exports.getRootUrl = getRootUrl;

var getNotFoundUrl = function getNotFoundUrl() {
  return _createInternalUrl('/not-found');
};

exports.getNotFoundUrl = getNotFoundUrl;

var getPricingPageUrl = function getPricingPageUrl(primaryNavId, query) {
  return _createInternalUrl("" + primaryNavId, {
    query: query
  });
};

exports.getPricingPageUrl = getPricingPageUrl;

var getPricingAndFeaturesPageUrl = function getPricingAndFeaturesPageUrl(query) {
  return _createExternalUrl("/browse/" + _PortalIdParser.default.get(), query);
};

exports.getPricingAndFeaturesPageUrl = getPricingAndFeaturesPageUrl;

var getProductTabUrl = function getProductTabUrl(productsAndPlansNavId, query) {
  return _createInternalUrl("" + productsAndPlansNavId, {
    query: query
  });
};

exports.getProductTabUrl = getProductTabUrl;

var langToUrl = function langToUrl(langMap) {
  var lang = (0, _getLang.default)();

  if (!Object.keys(langMap).includes(lang)) {
    _Raven.default.captureMessage('Unknown localeToUrl mapping', {
      level: 'warning',
      extra: {
        lang: lang,
        langMap: langMap
      }
    });

    if (!Object.keys(langMap).includes('en')) {
      _Raven.default.captureMessage('Must provide english fallback for localeToUrl', {
        extra: {
          lang: lang,
          langMap: langMap
        }
      });

      console.error('Error: Must provide english fallback for localeToUrl');
      return null;
    }

    return langMap.en;
  }

  return langMap[lang];
};

exports.langToUrl = langToUrl;

var getLegalSiteDomain = function getLegalSiteDomain() {
  var langMap = {
    en: 'https://legal.hubspot.com',
    de: 'https://legal.hubspot.com/de',
    es: 'https://legal.hubspot.com/es',
    pt: 'https://legal.hubspot.com/br',
    fr: 'https://legal.hubspot.com/fr',
    ja: 'https://legal.hubspot.com/jp'
  };
  return langToUrl(langMap);
};

var getSuiteLegalDisclaimerUrl = function getSuiteLegalDisclaimerUrl() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + "/growth-suite-bundle-pricing";
};

exports.getSuiteLegalDisclaimerUrl = getSuiteLegalDisclaimerUrl;

var getProductsAndServicesCatalogUrl = function getProductsAndServicesCatalogUrl() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + "/hubspot-product-and-services-catalog" + section;
};

exports.getProductsAndServicesCatalogUrl = getProductsAndServicesCatalogUrl;

var getLegalStuffSiteDomain = function getLegalStuffSiteDomain() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + "/legal-stuff";
};

exports.getLegalStuffSiteDomain = getLegalStuffSiteDomain;

var getPrivacyPolicySiteDomain = function getPrivacyPolicySiteDomain() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + "/privacy-policy";
};

exports.getPrivacyPolicySiteDomain = getPrivacyPolicySiteDomain;

var getHubspotForStartupsLandingPageUrl = function getHubspotForStartupsLandingPageUrl(source) {
  var domain = (0, _publicPageUrls.getPublicSiteDomain)();
  return domain + "/startups?source=" + source;
};

exports.getHubspotForStartupsLandingPageUrl = getHubspotForStartupsLandingPageUrl;

var getContactUsUrl = function getContactUsUrl() {
  var langMap = {
    en: 'https://hubspot.com/company/contact',
    de: 'https://hubspot.de/company/contact',
    es: 'https://hubspot.es/company/contact',
    pt: 'https://br.hubspot.com/company/contact',
    fr: 'https://hubspot.fr/company/contact',
    ja: 'https://hubspot.jp/company/contact'
  };
  return langToUrl(langMap);
};

exports.getContactUsUrl = getContactUsUrl;

var getHubSpotHomeUrl = function getHubSpotHomeUrl() {
  var langMap = {
    en: 'https://hubspot.com',
    de: 'https://hubspot.de',
    es: 'https://hubspot.es',
    pt: 'https://br.hubspot.com',
    fr: 'https://hubspot.fr',
    ja: 'https://hubspot.jp'
  };
  return langToUrl(langMap);
}; // TODO: update this when we get the desired url


exports.getHubSpotHomeUrl = getHubSpotHomeUrl;

var getLatamEsPromotionUrl = function getLatamEsPromotionUrl() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + "/latam-pricing-promotions";
};

exports.getLatamEsPromotionUrl = getLatamEsPromotionUrl;

var getBrazilPromotionUrl = function getBrazilPromotionUrl() {
  return 'https://br.hubspot.com/brazil-promo-terms-and-conditions';
};

exports.getBrazilPromotionUrl = getBrazilPromotionUrl;

var getHSFSPurchaseUrl = function getHSFSPurchaseUrl() {
  return _createExternalUrl("/hsfx-programs/" + _PortalIdParser.default.get() + "/application/finish");
};

exports.getHSFSPurchaseUrl = getHSFSPurchaseUrl;

var getHSFSApplicationURL = function getHSFSApplicationURL() {
  return _createExternalUrl("/hsfx-programs/" + _PortalIdParser.default.get() + "/application/company");
};

exports.getHSFSApplicationURL = getHSFSApplicationURL;

var getCommunityUrl = function getCommunityUrl() {
  return 'https://community.hubspot.com/';
};

exports.getCommunityUrl = getCommunityUrl;

var getPaidUserManagementUrl = function getPaidUserManagementUrl() {
  return _createExternalUrl("/settings/" + _PortalIdParser.default.get() + "/users/paid-users");
};

exports.getPaidUserManagementUrl = getPaidUserManagementUrl;

var getActiveQuoteUrl = function getActiveQuoteUrl(quoteId) {
  return _createExternalUrl("/checkout/" + _PortalIdParser.default.get() + "/quotes/" + quoteId);
}; // TODO can remove this function after 4/7


exports.getActiveQuoteUrl = getActiveQuoteUrl;

var getCmsRootUrl = function getCmsRootUrl(hasThemedContentCreatorAccess) {
  if (hasThemedContentCreatorAccess) {
    return _createExternalUrl("/website/" + _PortalIdParser.default.get() + "/pages/site?signupSrc=trialPricingPage");
  }

  return _createExternalUrl("/marketplace/" + _PortalIdParser.default.get() + "/products?childType=LANDING_PAGE&childType=SITE_PAGE&subType=COS_TEMPLATE_PACK");
};

exports.getCmsRootUrl = getCmsRootUrl;

var getCmsHubRootUrl = function getCmsHubRootUrl() {
  return _createExternalUrl("/website/" + _PortalIdParser.default.get() + "/splash");
};

exports.getCmsHubRootUrl = getCmsHubRootUrl;

var getGettingStartedPageUrl = function getGettingStartedPageUrl() {
  return _createExternalUrl("/getting-started/" + _PortalIdParser.default.get());
};

exports.getGettingStartedPageUrl = getGettingStartedPageUrl;

var getInboundPricingFaqUrl = function getInboundPricingFaqUrl() {
  return (0, _publicPageUrls.getPublicSiteDomain)() + "/inbound19-pricing-faq";
};

exports.getInboundPricingFaqUrl = getInboundPricingFaqUrl;

var getDTTUrl = function getDTTUrl(trialId, upgradeSource) {
  return _createExternalUrl("/signup/trial-signup?intent=trial&trialId=" + trialId + "&dtt_source=" + upgradeSource + "-pricing-page");
};

exports.getDTTUrl = getDTTUrl;

var remoteSalesToolsUrl = _createExternalUrl("/remote-business-tools/" + _PortalIdParser.default.get() + "/info?source=pricing-page"); // We should make this use a langMap for the global launch


exports.remoteSalesToolsUrl = remoteSalesToolsUrl;
var MC_LANDING_PAGE_URL = 'https://www.hubspot.com/marketing-contacts/anz';
exports.MC_LANDING_PAGE_URL = MC_LANDING_PAGE_URL;